<template>
    <el-form class="formView" :rules="rules" ref="feedForm" :model="feedForm" label-position="top" label-width="80px">
        <el-form-item label="反馈公厕：">
            <el-input v-model="title" disabled></el-input>
        </el-form-item>
        <el-form-item label="问题描述：" prop="content">
            <el-input v-model="feedForm.content" placeholder="请填写问题描述(至少5字)" type="textarea" rows="10" min="5"></el-input>
        </el-form-item>
        <el-form-item label="上传图片：">
            <el-upload
                action="/index.php?m=content&c=gongce&a=upload"
                multiple
                :on-success="uploadSuccess"
                name="uploadfile"
                list-type="picture-card">
                <i class="el-icon-plus"></i>
            </el-upload>
        </el-form-item>
        <el-form-item>
            <el-button @click="submitForm" style="width: 100%" type="primary">提交</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import axios from "axios";
    import * as qs from 'query-string'
    export default {
        name: "feedBack",
        data() {
            return {
                feedForm: {
                    title:'',
                    content:'',
                    pics:[]
                },
                rules:{
                    content:[
                        { required: true, message: '请输入内容', trigger: 'blur' },
                        { min: 5, message: '最少不能低于五个字', trigger: 'blur' }
                    ],
                }
            }
        },
        computed:{
            title(){
                return this.$route.query.title
            }
        },
        methods:{
            submitForm(){
                const {feedForm}=this
                feedForm.title=this.title
                if(feedForm.pics.length>0){
                    feedForm.pics=feedForm.pics.join(',')
                }else{
                    feedForm.pics=''
                }
                let params=new URLSearchParams()
                params.append('title',this.title)
                params.append('content',feedForm.content)
                params.append('pics',feedForm.pics)
                this.$refs['feedForm'].validate((valid) => {
                    if (valid) {
                        axios.post(`/index.php?m=content&c=gongce&a=feedback`,params).then(res => {
                            if(res.data.code===200){
                                this.$message.success('反馈成功')
                                this.$router.back()
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            uploadSuccess(res){
                this.feedForm.pics.push(res.data[0].fileurl)
            }
        }
    }
</script>
<style scoped>
    .formView{
        margin: 0 20px;
    }
</style>
